import {
  BinInfo,
  ChartDataPoint,
  GroupInfo,
  SitesInfo,
  RecentItems,
  BestRoute,
  CategoryCount,
  TotalDeviceCount,
  NameValue,
  OverviewChart,
  LoginRequest,
  LoginResponse,
  BinReportInfo,
  BinOverviewReportInfoResponse,
  BinOverviewReportCard,
  InfraReportInfoResponse,
  CorrosionoverviewData,
  SnapViewInfo,
  GetInfraTrendData,
  LabelsResponseData,
  InfraChartData,
  GetDetectionChartData,
  GetInfraDetectionTrendData,
  AgriChartData,
  AgriChartDataResp,
  TrackTruckData,
  CountChartData,
  RoutesSeverityChartData,
  SectorSeverityData,
  RfIdScannedData,
  FalsePositiveRequest,
  AgriReportSummaryRequest,
  LitterBin,
} from "../Models/Models";
import {
  RecentActivities,
  RecentInsights,
} from "../ContextAPI/WasteManagementContext";
import {
  CtmServices,
  SenszBoServices,
  SenszClientServices,
} from "./http-common";

//Common
const FetchSites = async (orgCode: string): Promise<SitesInfo[]> => {
  try {
    var resp = await SenszBoServices.get(`sites`, {
      params: { orgCode },
    });
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching Sites data:", error);
    throw error;
  }
};
const FetchSiteGroups = async (data: string): Promise<GroupInfo[]> => {
  try {
    var resp = await SenszBoServices.get(`sites/${data}/groups`);
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching SiteGroups data:", error);
    throw error;
  }
};

//-------------------->WasteManagement<-----------
const GetBinDetails = async (
  siteCode: string,
  groupCode: string
): Promise<BinInfo[]> => {
  try {
    var resp = await SenszClientServices.get(`devices/${siteCode}`, {
      params: {
        groupId: groupCode,
      },
    });
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching BinDetails data:", error);
    throw error;
  }
};
const GetBinFullnessChartData = async (
  siteCode: string,
  deviceCode: string
): Promise<ChartDataPoint[]> => {
  try {
    var resp = await SenszClientServices.get(`chart/${siteCode}/${deviceCode}`);
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching BinFullnessChart data:", error);
    throw error;
  }
};

//.................BinOverviwe..........................

const GetBinChartData = async (
  siteCode: string,
  type: string
): Promise<OverviewChart[]> => {
  try {
    const response = await SenszClientServices.get(`/chart/${siteCode}/group`, {
      params: {
        type: type,
      },
    });
    return response.data.response.body;
  } catch (error) {
    console.error("Error fetching BinChart data:", error);
    throw error;
  }
};

const GetBinCardData = async (
  siteCode: string,
  fromDate: string
): Promise<NameValue[]> => {
  try {
    var resp = await SenszClientServices.get(`/chart/${siteCode}/group/avg`, {
      params: { fromDate },
    });
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching BinCard data:", error);
    throw error;
  }
};

const GetTotalBinCardData = async (
  siteCode: string,
  fromDate: string
): Promise<OverviewChart> => {
  try {
    var resp = await SenszClientServices.get(`/chart/${siteCode}/group/type`, {
      params: { fromDate },
    });
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching TotalBinCard data:", error);
    throw error;
  }
};
//.......................Corrosionoverview...........................
const GetCorrosionGraphData = async (
  siteCode: string,
  type: string,
  groupId: string,
  interval: string
): Promise<CorrosionoverviewData[]> => {
  try {
    const response = await SenszClientServices.get(
      `/chart/${siteCode}/group/infra`,
      {
        params: {
          type,
          interval,
          groupId,
        },
      }
    );
    return response.data.response.body;
  } catch (error) {
    console.error("Error fetching corrosionGraph data:", error);
    throw error;
  }
};

const GetSnapViewCardData = async (
  siteCode: string,
  fromDate: string,
  type: string,
  groupId: string
): Promise<SnapViewInfo[]> => {
  try {
    var resp = await SenszClientServices.get(`/devices/${siteCode}/snapview`, {
      params: { fromDate, type, groupId },
    });
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching snapViewCard data:", error);
    throw error;
  }
};

const GetCorrosionChartData = async (
  siteCode: string,
  type: string,
  groupId: string,
  interval: string
): Promise<InfraChartData[]> => {
  try {
    const response = await SenszClientServices.get(
      `/chart/${siteCode}/group/infra/trends`,
      {
        params: {
          type,
          interval,
          groupId,
        },
      }
    );
    return response.data.response.body;
  } catch (error) {
    console.error("Error fetching corrosionChart data:", error);
    throw error;
  }
};

const DetectionTypeGraphData = async (
  siteCode: string,
  groupId: string,
  interval: string
): Promise<GetDetectionChartData[]> => {
  try {
    const response = await SenszClientServices.get(
      `/chart/${siteCode}/group/infra/detections`,
      {
        params: {
          interval,
          groupId,
        },
      }
    );
    return response.data.response.body;
  } catch (error) {
    console.error("Error fetching detectionTypeGraph data:", error);
    throw error;
  }
};

const DetectionTypeChartData = async (
  siteCode: string,
  groupId: string,
  interval: string
): Promise<GetInfraDetectionTrendData[]> => {
  try {
    const response = await SenszClientServices.get(
      `/chart/${siteCode}/group/infra/detections/trends`,
      {
        params: {
          interval,
          groupId,
        },
      }
    );
    return response.data.response.body;
  } catch (error) {
    console.error("Error fetching detectionTypeChart data:", error);
    throw error;
  }
};

//.......................Agriculture...........................

const FetchAgriLables = async (
  siteCode: string
): Promise<LabelsResponseData> => {
  var resp = await SenszClientServices.get(`/chart/${siteCode}/labels`);
  return resp.data.response.body;
};

const GetAgriChartData = async (
  siteCode: string,
  interval: string,
  label: string,
  type: string
): Promise<AgriChartData[]> => {
  try {
    const response = await SenszClientServices.get(
      `/chart/${siteCode}/agri/chart`,
      {
        params: {
          interval,
          label,
          type,
        },
      }
    );
    console.log(response.data.response.body, "response.data.response.body");
    return response.data.response.body;
  } catch (error) {
    console.error("Error fetching chart data:", error);
    return [];
  }
};

const GetAgriTrendData = async (
  siteCode: string,
  label: string,
  type: string
): Promise<AgriChartDataResp[]> => {
  try {
    const response = await SenszClientServices.get(
      `/chart/${siteCode}/agri/trend`,
      {
        params: {
          label,
          type,
        },
      }
    );
    console.log(response.data.response.body, "response.data.response.body");
    return response.data.response.body;
  } catch (error) {
    console.error("Error fetching chart data:", error);
    return [];
  }
};

//.......................Wasteoverview...........................

const GetWasteChartData = async (
  siteCode: string,
  type: string
): Promise<OverviewChart[]> => {
  try {
    const response = await SenszClientServices.get(
      `/chart/${siteCode}/group/collection`,
      {
        params: {
          type: type, // Use the dynamic type parameter here
        },
      }
    );
    return response.data.response.body;
  } catch (error) {
    console.error("Error fetching wasteChart data:", error);
    throw error;
  }
};

const GetWasteCardData = async (
  siteCode: string,
  fromDate: string
): Promise<NameValue[]> => {
  try {
    var resp = await SenszClientServices.get(
      `/chart/${siteCode}/group/collection/avg`,
      {
        params: { fromDate },
      }
    );
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching wastecard data:", error);
    throw error;
  }
};

const GetTotalWasteCardData = async (
  siteCode: string,
  fromDate: string
): Promise<OverviewChart> => {
  try {
    var resp = await SenszClientServices.get(
      `/chart/${siteCode}/group/collection/type`,
      {
        params: { fromDate },
      }
    );
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching totalWasteCard data:", error);
    throw error;
  }
};

const GetRecentActivities = async (
  siteCode: string
): Promise<RecentActivities[]> => {
  try {
    var resp = await SenszClientServices.get(
      `devices/${siteCode}/recent/activities`
    );
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching recentActivities data:", error);
    throw error;
  }
};

const GetAllRecentInsights = async (
  siteCode: string,
  fromDate: string,
  endDate: string
): Promise<RecentActivities[]> => {
  try {
    var resp = await SenszClientServices.get(
      `devices/${siteCode}/recent/insights`,
      {
        params: { fromDate, endDate },
      }
    );
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching recentActivities data:", error);
    throw error;
  }
};

const GetRecentInsights = async (
  siteCode: string
): Promise<RecentInsights[]> => {
  try {
    var resp = await SenszClientServices.get(
      `devices/${siteCode}/recent/insights`
    );
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching recentInsights data:", error);
    throw error;
  }
};

const GetCountByCategory = async (
  siteCode: string
): Promise<CategoryCount[]> => {
  try {
    var resp = await SenszClientServices.get(`chart/${siteCode}/group/counts`);
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching CountByCatagory data:", error);
    throw error;
  }
};

const GetCountTotal = async (siteCode: string): Promise<TotalDeviceCount> => {
  try {
    var resp = await SenszClientServices.get(`devices/${siteCode}/counts`);
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching CountTotal data:", error);
    throw error;
  }
};

const GetBestRoute = async (siteCode: string): Promise<BestRoute[]> => {
  try {
    var resp = await SenszClientServices.get(
      `devices/${siteCode}/plot/direction`
    );
    return resp.data.response.body; // body is an object, not an array
  } catch (error) {
    console.error("Error fetching bestRoute data:", error);
    throw error;
  }
};

const login = async (credentials: LoginRequest): Promise<LoginResponse> => {
  try {
    const response = await SenszBoServices.post<LoginResponse>(
      "/user/login",
      credentials
    );
    return response.data;
  } catch (error) {
    console.error("Error while  login :", error);
    throw error;
  }
};

//  .................. Report Summary.................

const FetchBinReport = async (
  siteCode: string,
  pageNo: number,
  pageSize: number,
  fromDate: string | null,
  groupId: string
): Promise<BinOverviewReportInfoResponse> => {
  try {
    const resp = await SenszClientServices.get(
      `/report/${siteCode}/binoverview`,
      {
        params: {
          pageNo: pageNo,
          pageSize: pageSize,
          fromDate: fromDate ?? "",
          groupId: groupId,
        },
      }
    );
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching binReport data:", error);
    throw error;
  }
};

const FetchBinCardReport = async (
  siteCode: string,
  fromDate: string,
  groupId: string
): Promise<BinOverviewReportCard> => {
  try {
    const resp = await SenszClientServices.get(
      `/report/${siteCode}/binoverview/card`,
      {
        params: {
          fromDate: fromDate,
          groupId: groupId,
        },
      }
    );
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching BinCardReport data:", error);
    throw error;
  }
};

const FetchWasteReport = async (
  siteCode: string,
  pageNo: number,
  pageSize: number,
  fromDate: string,
  groupId: string
): Promise<BinOverviewReportInfoResponse> => {
  try {
    const resp = await SenszClientServices.get(
      `/report/${siteCode}/wastecollection`,
      {
        params: {
          pageNo: pageNo,
          pageSize: pageSize,
          fromDate: fromDate,
          groupId: groupId,
        },
      }
    );
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching wasteReport data:", error);
    throw error;
  }
};

const FetchWasteCardReport = async (
  siteCode: string,
  fromDate: string,
  groupId: string
): Promise<BinOverviewReportCard> => {
  try {
    const resp = await SenszClientServices.get(
      `/report/${siteCode}/wastecollection/card`,
      {
        params: {
          fromDate: fromDate,
          groupId: groupId,
        },
      }
    );
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching wasteCardReport data:", error);
    throw error;
  }
};

const FetchInfraCardReport = async (
  siteCode: string,
  type: string,
  fromDate: string,
  groupId: string
): Promise<BinOverviewReportCard> => {
  try {
    const resp = await SenszClientServices.get(
      `/report/${siteCode}/infra/card`,
      {
        params: {
          type: type,
          fromDate: fromDate,
          groupId: groupId,
        },
      }
    );
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching infraCardReport data:", error);
    throw error;
  }
};

const FetchInfraReport = async (
  siteCode: string,
  pageNo: number,
  pageSize: number,
  fromDate: string,
  type: string,
  groupId: string
): Promise<InfraReportInfoResponse> => {
  try {
    const resp = await SenszClientServices.get(`/report/${siteCode}/infra`, {
      params: {
        pageNo: pageNo,
        pageSize: pageSize,
        fromDate: fromDate,
        type: type,
        groupId: groupId,
      },
    });
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching infraReport data:", error);
    throw error;
  }
};

const GetDLCCardData = async (
  siteCode: string,
  fromDate: string
): Promise<NameValue[]> => {
  try {
    var resp = await SenszClientServices.get(
      `/chart/${siteCode}/dic/overview`,
      {
        params: {
          fromDate: fromDate,
        },
      }
    );
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching DLCCard data:", error);
    throw error;
  }
};

const GetDLCCardAllCategoriesData = async (
  siteCode: string,
  fromDate: string
): Promise<NameValue[]> => {
  try {
    var resp = await SenszClientServices.get(`/chart/${siteCode}/dic/avg`, {
      params: {
        fromDate: fromDate,
      },
    });
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching DicCard data:", error);
    throw error;
  }
};

const GetDLCChartData = async (
  siteCode: string,
  type: string
): Promise<OverviewChart[]> => {
  try {
    const response = await SenszClientServices.get(`/chart/${siteCode}/dic`, {
      params: {
        type: type, // Use the dynamic type parameter here
      },
    });
    return response.data.response.body;
  } catch (error) {
    console.error("Error fetching dicChart data:", error);
    throw error;
  }
};

const FetchDLCCardReport = async (
  siteCode: string,
  fromDate: string,
  groupId: string
): Promise<BinOverviewReportCard> => {
  try {
    const resp = await SenszClientServices.get(`/report/${siteCode}/dic/card`, {
      params: {
        fromDate: fromDate,
        groupId: groupId,
      },
    });

    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching dicCardReport data:", error);
    throw error;
  }
};

const FetchDLCReportExport = async (
  siteCode: string,
  fromDate: string,
  groupId: string
): Promise<Blob> => {
  try {
    const resp = await SenszClientServices.get(
      `report/${siteCode}/dic/download`,
      {
        params: {
          fromDate: fromDate,

          groupId: groupId,
        },

        responseType: "blob", // Ensures that the response data is in binary format
      }
    );
    return resp.data;
  } catch (error) {
    console.error("Error fetching dicReportExport data:", error);
    throw error;
  }
};

const FetchDLCReport = async (
  siteCode: string,
  pageNo: number,
  pageSize: number,
  fromDate: string,
  groupId: string
): Promise<BinOverviewReportInfoResponse> => {
  try {
    const resp = await SenszClientServices.get(`/report/${siteCode}/dic`, {
      params: {
        pageNo: pageNo,
        pageSize: pageSize,
        fromDate: fromDate,
        groupId: groupId,
      },
    });
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching dicReport data:", error);
    throw error;
  }
};

const GetDLCLastTenDaysChartData = async (
  siteCode: string,
  deviceCode: string
): Promise<ChartDataPoint[]> => {
  try {
    var resp = await SenszClientServices.get(`chart/${siteCode}/${deviceCode}`);
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching dicLastTEnDays data:", error);
    throw error;
  }
};

const GetDLCDetails = async (
  siteCode: string,
  groupCode: string
): Promise<BinInfo[]> => {
  try {
    var resp = await SenszClientServices.get(`devices/${siteCode}`, {
      params: {
        groupId: groupCode,
      },
    });
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching dicDetails data:", error);
    throw error;
  }
};
//.......................Ctm Services...........................

const GetAssetCount = async (): Promise<CountChartData[]> => {
  try {
    var resp = await CtmServices.get(`geo/assets/count`);
    return resp.data.data;
  } catch (error) {
    console.error("Error fetching AssetCount data:", error);
    throw error;
  }
};

const GetLapsesCount = async (): Promise<CountChartData[]> => {
  try {
    var resp = await CtmServices.get(`geo/lapses/count`);
    return resp.data.data;
  } catch (error) {
    console.error("Error fetching LapsesCount data:", error);
    throw error;
  }
};

const GetRouteSeverity = async (): Promise<RoutesSeverityChartData[]> => {
  try {
    var resp = await CtmServices.get(`geo/routes/severity`);
    return resp.data.data;
  } catch (error) {
    console.error("Error fetching routeSeverity data:", error);
    throw error;
  }
};

const GetSectorSeverity = async (): Promise<SectorSeverityData> => {
  try {
    var resp = await CtmServices.get(`geo/sector/severity`);
    return resp.data.data;
  } catch (error) {
    console.error("Error fetching sectorSeverity data:", error);
    throw error;
  }
};

const GetStreetSeverity = async (): Promise<CountChartData[]> => {
  try {
    var resp = await CtmServices.get(`geo/streets/severity`);
    return resp.data.data;
  } catch (error) {
    console.error("Error fetching streetsSeverity data:", error);
    throw error;
  }
};

const GetMapView = async (
  type: string,
  selectedtime: string
): Promise<TrackTruckData[]> => {
  try {
    var resp = await CtmServices.get(`/geo/map/plots/view`, {
      params: {
        type,
        selectedtime,
      },
    });
    return resp.data.data;
  } catch (error) {
    console.error("Error fetching ctmMapView data:", error);
    throw error;
  }
};

const GetRfIdScannedData = async (type: string): Promise<RfIdScannedData[]> => {
  try {
    var resp = await CtmServices.get(`devices/rfid/data`, {
      params: {
        type,
      },
    });
    return resp.data.data;
  } catch (error) {
    console.error("Error fetching rfIdscanned data:", error);
    throw error;
  }
};

const UpdateFalsePositiveStatus = async (
  FalsePositiveReq: FalsePositiveRequest
): Promise<any> => {
  try {
    var resp = await CtmServices.put(`/geo/status`, FalsePositiveReq);
    return resp.data.data;
  } catch (error) {
    console.error("Error fetching UpdateFalsePositiveStatus data:", error);
    throw error;
  }
};

const FetchAgriCardReport = async (
  req: AgriReportSummaryRequest
): Promise<BinOverviewReportCard> => {
  try {
    const resp = await SenszClientServices.get(
      `/report/${req.siteCode}/agri/card`,
      {
        params: {
          name: req.type,
          fromDate: req.fromDate,
          groupId: req.groupId,
        },
      }
    );
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching Agriculture Card Report data:", error);
    throw error;
  }
};

const FetchAgriReport = async (
  req: AgriReportSummaryRequest
): Promise<InfraReportInfoResponse> => {
  try {
    const resp = await SenszClientServices.get(`/report/${req.siteCode}/agri`, {
      params: {
        pageNo: req.pageNo,
        pageSize: req.pageSize,
        fromDate: req.fromDate,
        type: req.type,
        groupId: req.groupId,
      },
    });
    return resp.data.response.body;
  } catch (error) {
    console.error("Error fetching Agriculture Card Report data:", error);
    throw error;
  }
};

const GetMapLitterView = async (deviceType: string): Promise<LitterBin[]> => {
  try {
    var resp = await CtmServices.get(`/devices`, {
      params: {
        deviceType,
      },
    });
    return resp.data.data;
  } catch (error) {
    console.error("Error fetching LitterBinView data:", error);
    throw error;
  }
};

export {
  FetchSites,
  FetchSiteGroups,
  GetRecentActivities,
  GetRecentInsights,
  GetCountByCategory,
  GetCountTotal,
  GetBestRoute,
  GetBinDetails,
  GetBinFullnessChartData,
  GetBinChartData,
  GetBinCardData,
  GetTotalBinCardData,
  GetWasteChartData,
  GetWasteCardData,
  GetTotalWasteCardData,
  login,
  FetchBinReport,
  FetchBinCardReport,
  FetchWasteReport,
  FetchWasteCardReport,
  FetchInfraCardReport,
  FetchInfraReport,
  GetCorrosionGraphData,
  GetSnapViewCardData,
  GetCorrosionChartData,
  DetectionTypeGraphData,
  DetectionTypeChartData,
  FetchAgriCardReport,
  FetchAgriReport,
  FetchAgriLables,
  GetAgriChartData,
  GetAgriTrendData,
  GetDLCChartData,
  FetchDLCReportExport,
  FetchDLCCardReport,
  FetchDLCReport,
  GetDLCCardData,
  GetDLCLastTenDaysChartData,
  GetDLCDetails,
  GetDLCCardAllCategoriesData,
  GetAssetCount,
  GetLapsesCount,
  GetRouteSeverity,
  GetSectorSeverity,
  GetStreetSeverity,
  GetMapView,
  GetRfIdScannedData,
  UpdateFalsePositiveStatus,
  GetMapLitterView,
  GetAllRecentInsights,
};
